import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";

export const selectSupplier = createSelector(selectCreateShipmentForm, (createShipment) => createShipment.supplier);
